import React from 'react';

import PolymerIcon from '@material-ui/icons/Polymer';
import AppsIcon from '@material-ui/icons/Apps';
import RunIcon from '@material-ui/icons/DirectionsRun';
import TimerIcon from '@material-ui/icons/Timer';
import WeekendIcon from '@material-ui/icons/Weekend';
import FitnessIcon from '@material-ui/icons/FitnessCenter';
import FireIcon from '@material-ui/icons/Whatshot';
import RadioButtonCheck from '@material-ui/icons/RadioButtonChecked';

import * as Utils from '../../lib/designerUtils';
import Console from '../../lib/debug';

const BlockTypeIcon = props => {
    Console.render('BlockTypeIcon');
    switch (props.type) {
        case Utils.BlockTypes.UNCATEGORIZED:
            return <AppsIcon className="block-type-0" />;
        case Utils.BlockTypes.PREP:
            return <FireIcon className="block-type-1" />;
        case Utils.BlockTypes.SPEED_AGILITY:
            return <RunIcon className="block-type-2" />;
        case Utils.BlockTypes.SKILL_TECH:
            return <RadioButtonCheck className="block-type-3" />;
        case Utils.BlockTypes.STRENGTH_POWER:
            return <FitnessIcon className="block-type-4" />;
        case Utils.BlockTypes.CONDITIONING:
            return <TimerIcon className="block-type-5" />;
        case Utils.BlockTypes.RECOVERY:
            return <WeekendIcon className="block-type-6" />;
        case Utils.BlockTypes.SURVEY:
            return <PolymerIcon className="block-type-7" />;
        case Utils.BlockTypes.BIOMETRIC:
            return <PolymerIcon className="block-type-8" />;
        default:
            return <div>Error</div>;
    }
};

export default BlockTypeIcon;
